import { Link } from "react-router-dom";
import "./footer.css";

const Footer = ({ content }: any) => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footerContainer d-none">
      <div className="d-flex flex-row flex-wrap justify-content-center bg-light-blue p-0 m-0 pt-2">
        {false && (
          <div className="word-unwrap">
            <Link to="/about" className="text-footer">
              <span className="word-unwrap"> About</span>
            </Link>
          </div>
        )}
        {false && (
          <div className="word-unwrap">
            <Link to="/contact-us" className="text-footer">
              <span className="word-unwrap"> Contact</span>
            </Link>
          </div>
        )}

        {/* Must be defined by the marketing/product team */}
        {false && (
          <div className="word-unwrap">
            <Link to="/features" className="text-footer">
              <span className="word-unwrap"> Features and Tools</span>
            </Link>
          </div>
        )}

        {/* Must be defined by the marketing/product team */}
        {false && (
          <div className="word-unwrap">
            <Link to="/plans" className="text-footer">
              <span className="word-unwrap"> Plans </span>
            </Link>
          </div>
        )}
        {false && (
          <div className="word-unwrap">
            <Link to="/privacy" className="text-footer">
              <span className="word-unwrap"> Privacy Policy</span>
            </Link>
          </div>
        )}
        {false && (
          <div className="word-unwrap">
            <Link to="/termsconditions" className="text-footer">
              <span className="word-unwrap"> Terms and Conditions</span>
            </Link>
          </div>
        )}

        {/* Must be defined by the marketing/product team */}
        {false && (
          <div className="word-unwrap">
            <Link to="/aerodromes" className="text-footer">
              <span className="word-unwrap"> Available Aerodromes </span>
            </Link>
          </div>
        )}
      </div>
      <div className="p-0 m-0 d-flex flex-row flex-wrap justify-content-center bg-light-blue pb-2">
        <span className="text-footer">
          Copyright © {currentYear} EngiSeek Pty Ltd ABN: 21 625 532 096
        </span>
      </div>
    </div>
  );
};

export default Footer;
